module.exports = __webpack_public_path__ + "static/media/faq.ffb0fd40.png";